import React from "react";
import { Check, Info } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { SectionHeader, FadeUp, Marquee } from "../components/primitives";
import { LeadForm } from "../components/LeadForm";
import { useLang } from "../i18n";

const ForPublishers = () => {
  const { t } = useLang();
  return (
    <div className="overflow-hidden">
      <PageHero over={t.publishers.heroOver} title={t.publishers.heroTitle} sub={t.publishers.heroSub} />

      <Marquee words="MONETIZE YOUR TRAFFIC" />

      <section className="py-24 md:py-32 bg-white">
        <div className="mx-auto max-w-[1500px] px-5 md:px-10">
          <SectionHeader over={t.publishers.whyOver} title={t.publishers.whyTitle} />
          <div className="mt-16 grid md:grid-cols-2 gap-x-16 gap-y-2">
            {t.publishers.why.map((w, i) => (
              <FadeUp key={i} delay={(i % 2) * 0.08}>
                <div className="group flex items-center gap-5 py-6 border-b border-wanm-dark/10 hover:pl-2 transition-all" data-testid={`pub-why-${i}`}>
                  <div className="w-10 h-10 rounded-full bg-wanm-offwhite flex items-center justify-center shrink-0 group-hover:wanm-gradient-bg transition-all">
                    <Check className="text-wanm-red group-hover:text-white transition-colors" size={18} />
                  </div>
                  <span className="text-xl md:text-2xl font-bold text-wanm-dark">{w}</span>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-wanm-dark text-white" id="form">
        <div className="mx-auto max-w-4xl px-5 md:px-10">
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-sm font-black uppercase tracking-[0.25em] text-wanm-orange">{t.publishers.formOver}</span>
            <h2 className="mt-5 text-4xl md:text-5xl font-black tracking-tight">{t.publishers.formTitle}</h2>
            <div className="mt-6 inline-flex items-start gap-2 text-white/50 text-sm bg-white/5 rounded-xl px-4 py-3">
              <Info size={16} className="mt-0.5 shrink-0" /><span>{t.publishers.disclaimer}</span>
            </div>
          </div>
          <div className="mt-12 bg-white rounded-3xl p-8 md:p-12">
            <LeadForm endpoint="/leads/publisher" testId="publisher-form" submitLabel={t.cta.apply}
              fields={[
                { id: "name", required: true }, { id: "company" },
                { id: "email", type: "email", required: true }, { id: "country" },
                { id: "website" }, { id: "traffic_sources" }, { id: "verticals" },
                { id: "monthly_traffic" }, { id: "networks" }, { id: "message", textarea: true },
              ]} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForPublishers;
